<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> AADHAAR KYC</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
        novalidate>
        <div class="row mb-2">
            <div class="btn-group btn-group-toggle">
                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                    <input class="form-check-input" type="radio" [value]=true name="kycType" [(ngModel)]="IsOkyc"
                        [ngModelOptions]="{standalone: true}">
                    <img src="../../../../assets/Aadhaar_Logo.svg.webp" style="height:25px"> OKYC
                </label>
                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                    <input class="form-check-input" type="radio" [value]=false name="kycType" [(ngModel)]="IsOkyc"
                        [ngModelOptions]="{standalone: true}">
                    <img src="../../../../assets/digilocker.svg" style="height:25px"> Digi Locker
                </label>
            </div>
        </div>
        <div class="row" *ngIf="ReturnDetail.AADHAARVerificationID == null">
            <div class="col-md-12">
                <div class="input-group mb-3">
                    <span class="input-group-text" id="lblAadharNo">Aadhar No</span>
                    <input type="text" class="form-control" placeholder="Aadhar No" aria-label="Aadhar No" id="AadharNo"
                        name="AadharNo" [(ngModel)]="AadhaarDetail.AadhaarNo" #AadharNo="ngModel" minlength="12"
                        maxlength="12" required aria-describedby="lblAadharNo" [disabled]="AadhaarDetail.SendOTP"
                        pattern="^[0-9]\d*$" (keypress)="common.NumberOnly($event)">
                    <div class="invalid-feedback">
                        Please enter 12 digit aadhaar no!
                    </div>
                </div>
            </div>
            <div class="col-md-12" *ngIf="AadhaarDetail.SendOTP">
                <div class="input-group mb-3">
                    <span class="input-group-text" id="lblOTP">OTP</span>
                    <input type="text" maxLength="10" (keypress)="common.NumberOnly($event)" pattern="^[0-9]\d*$"
                        class="form-control" placeholder="OTP" aria-label="OTP" id="OTP" name="OTP"
                        [(ngModel)]="AadhaarDetail.OTP" #OTP="ngModel" required aria-describedby="lblOTP">
                </div>
                <div class="invalid-feedback">
                    Please enter otp!
                </div>
            </div>
            <div class="col-md-12" *ngIf="AadhaarDetail.SendOTP">
                <label (click)="ResendAadharOTP()" class="Resend" *ngIf="!otpButtonDisable"><i
                        class="bi bi-arrow-clockwise"></i> Resend
                    OTP</label>

                <span class="Resend" *ngIf="otpButtonDisable"><i class="bi bi-arrow-clockwise"></i> Resend
                    OTP
                    after {{timingsixty}} sec</span>
            </div>
        </div>
        <div class="row" *ngIf="ReturnDetail.AADHAARVerificationID != null">
            <div class="col-md-3">
                <img [src]="ReturnDetail.photo" style="background-color: white;" class="registrationImage">
            </div>
            <div class="col-md-9">
                <div class="row">
                    <div class="col-md-12"
                        style="background-image: url(../../../assets/aadharbackground.jpg);background-size: cover;background-color: #fff;background-repeat: no-repeat;background-position: center">
                        <div class="row" style="margin-top: 9rem;">
                            <div class="col-md-auto aadharLabel">
                                <label class="text-label-dark">Aadhaar Number</label>
                            </div>
                            <div class="col-md">
                                <label class="text-label-light">{{ReturnDetail.AadharNoKyc}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-auto aadharLabel">
                                <label class="text-label-dark">Name as Aadhaar</label>
                            </div>
                            <div class="col-md">
                                <label class="text-label-light">{{ReturnDetail.NameAsPerAadhaar}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-auto aadharLabel">
                                <label class="text-label-dark">Date of Birth</label>
                            </div>
                            <div class="col-md">
                                <label class="text-label-light">{{ReturnDetail.BirthDate}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-auto aadharLabel">
                                <label class="text-label-dark">Gender</label>
                            </div>
                            <div class="col-md">
                                <label
                                    class="text-label-light">{{common.ToLowerCase(ReturnDetail.Gender)=='m'?'Male':common.ToLowerCase(ReturnDetail.Gender)=='f'?'Female':ReturnDetail.Gender!=null?'Other':''}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-auto aadharLabel">
                                <label class="text-label-dark">Address 1</label>
                            </div>
                            <div class="col-md">
                                <label class="text-label-light">{{ReturnDetail.LocalAddress1}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-auto aadharLabel">
                                <label class="text-label-dark">Address 2</label>
                            </div>
                            <div class="col-md">
                                <label class="text-label-light">{{ReturnDetail.LocalAddress2}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12" *ngIf="IsOkyc">
                <button *ngIf="ReturnDetail.AADHAARVerificationID == null" type="submit" class="btn btn-primary"
                    [disabled]="isDisabled" style="width: 100%">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?AadhaarDetail.SendOTP?'Verify':'OKYC':'Loading...'}}</button>
            </div>
            <div class="col-12" *ngIf="!IsOkyc">
                <button *ngIf="ReturnDetail.AADHAARVerificationID == null" type="submit" class="btn btn-primary"
                    [disabled]="isDisabled" style="width: 100%">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Digi Locker':'Loading...'}}</button>
            </div>
            <div class="col-12">
                <button *ngIf="ReturnDetail.AADHAARVerificationID != null" type="button" class="btn btn-primary"
                    [disabled]="isDisabled" (click)="Confirm()" style="width: 100%">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Confirm':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>